import { Component, ojs, app, each } from "modular-openscriptjs";
import { either, uniqueId } from "../../helpers";

const h = app("h");

export default class Tabs extends Component {
	render(config, ...args) {
		config.reversed = config.reversed ?? false;

		let {
			holders: { nav, body },
			tabs,
			reversed,
		} = config;

		for (let { tab, content } of tabs) {
			let id = `tb-${uniqueId()}`;

			tab.setAttribute("data-bs-toggle", "tab");
			tab.setAttribute("data-bs-target", `[tab-hook="${id}"]`);
			tab.setAttribute("type", "button");
			tab.setAttribute("role", "tab");

			content.setAttribute("role", "tabpanel");
			content.setAttribute("tabindex", "0");
			content.setAttribute("tab-hook", id);

			nav.append(tab);
			body.append(content);
		}

		nav.setAttribute("role", "tablist");

		return h.div(either(!reversed, [nav, body], [body, nav]), ...args);
	}
}
